import { cn } from "components/lib/utils";
import { SectionReviewState } from "generated/graphql";
import { usePopover } from "helpers/hooks/usePopover";
import { REVIEW_STATE_UI } from "./REVIEW_STATE_UI";
import { ArrowDropDown } from "@mui/icons-material";
import { Card, Popover } from "@mui/material";
import { assertNever } from "helpers/utils";

function SectionStatusItem({
  reviewState,
  onClick,
}: {
  reviewState: SectionReviewState;
  onClick: (reviewState: SectionReviewState) => Promise<void>;
}) {
  return (
    <div
      className="px-4 py-2 flex gap-2 items-center cursor-pointer hover:bg-gray-50"
      onClick={() => onClick(reviewState)}>
      <p className="text-sm font-semibold">{REVIEW_STATE_UI[reviewState].name}</p>
    </div>
  );
}

interface SectionStatusPickerProps {
  className?: string | undefined;
  reviewState: SectionReviewState;
  outcomeEnabled: boolean;
  validationEnabled: boolean;
  onChange: (reviewState: SectionReviewState) => void;
}

export function SectionStatusPicker(props: SectionStatusPickerProps) {
  const popover = usePopover();

  return (
    <>
      <button
        onClick={(evt) => popover.onPopoverOpen(evt.currentTarget)}
        className={cn("uppercase rounded-md text-sm font-semibold py-1 px-2 flex items-center", props.className)}>
        {REVIEW_STATE_UI[props.reviewState].name}
        <ArrowDropDown />
      </button>
      <Popover
        open={popover.isOpen}
        anchorEl={popover.anchorEl}
        onClose={popover.onPopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{ maxWidth: 1200 }}>
        <Card className="flex flex-col">
          {REVIEW_STATE_UI[props.reviewState].movableStates
            .filter((rs: SectionReviewState) => {
              if (rs === SectionReviewState.Complete) {
                return true;
              } else if (rs === SectionReviewState.Review) {
                return props.outcomeEnabled;
              } else if (rs === SectionReviewState.Validation) {
                return props.validationEnabled;
              } else {
                return assertNever(rs);
              }
            })
            .map((rs: SectionReviewState) => (
              <SectionStatusItem onClick={async () => props.onChange(rs)} key={rs} reviewState={rs} />
            ))}
        </Card>
      </Popover>
    </>
  );
}
